import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import ContentSection from './components/ContentSection';
import FeatureSection from './components/FeatureSection';
import SEOContentSection from './components/SEOContentSection';
import CTASection from './components/CTASection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://superbuyspread.hair';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Superbuy Spreadsheet',
  url: siteUrl,
  description:
    'The complete shopping management system for global buyers. Track products, calculate shipping costs, organize orders, and optimize every purchase decision with powerful spreadsheet tools.',
  inLanguage: 'en',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?s={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SchemaOrg data={websiteSchema} />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <ContentSection />
        <FeatureSection />
        <SEOContentSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}